
  <div class="emoji-mart-search">
    <input #inputRef type="text"
      (keyup.enter)="handleEnterKey($event)"
      [placeholder]="i18n.search" [autofocus]="autoFocus"
      [(ngModel)]="query" (ngModelChange)="handleChange()" />
    <button class="emoji-mart-search-icon"
      (click)="clear()"
      (keyup.enter)="clear()"
      [disabled]="!isSearching">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="13" height="13" opacity="0.5">
        <path [attr.d]="icon" />
      </svg>
    </button>
  </div>
  